import type { BootstrapSummary } from '@core/entities/BootstrapSummary';
import type { BootstrapGateway } from '@core/ports/BootstrapGateway';

export class GetBootstrapSummaryUseCase {
  public constructor(private readonly bootstrapGateway: BootstrapGateway) {}

  public async execute(): Promise<BootstrapSummary> {
    const summary = await this.bootstrapGateway.getBootstrapSummary();
    await this.bootstrapGateway.confirmJourneyStartAvailability();

    return summary;
  }
}